/**
 * 全平台统一 JSBridge 实现
 */
const normalizeNativePayload = (payload) => {
    if (payload === undefined) return undefined;
    if (payload === null) return null;

    if (typeof payload !== "string") return payload;

    const raw = payload.trim();
    if (!raw) return raw;
    if (raw === "undefined") return undefined;
    if (raw === "null") return null;

    const tryParse = (value) => {
        try {
            return { ok: true, value: JSON.parse(value) };
        } catch (e) {
            return { ok: false, error: e };
        }
    };

    let parsed = tryParse(raw);
    if (!parsed.ok) {
        const unwrapped =
            (raw.startsWith('"') && raw.endsWith('"')) || (raw.startsWith("'") && raw.endsWith("'"))
                ? raw.slice(1, -1)
                : raw;
        if (unwrapped !== raw) {
            parsed = tryParse(unwrapped.replace(/\\"/g, '"'));
        }
    }

    if (!parsed.ok) return payload;

    let value = parsed.value;
    for (let i = 0; i < 2; i += 1) {
        if (typeof value !== "string") break;
        const nextRaw = value.trim();
        if (
            !(nextRaw.startsWith("{") || nextRaw.startsWith("[") || nextRaw.startsWith('"') || nextRaw.startsWith("'"))
        ) {
            break;
        }
        const nextParsed = tryParse(nextRaw);
        if (!nextParsed.ok) break;
        value = nextParsed.value;
    }

    return value;
};

const MyJSBridge = {
    // 发送消息
    send: (action, params) => {
        // 1. iOS 适配
        if (window.webkit?.messageHandlers[action]) {
            window.webkit.messageHandlers[action].postMessage(params);
            return;
        }
        // 2. Android 适配 (Android 建议传字符串防止某些版本解析异常)
        else if (window.AndroidBridge) {
            window.AndroidBridge[action](JSON.stringify(params));
            return;
        } else {
            console.error("未检测到 Native 环境");
            return;
        }
    },
    // 监听回调
    listen: (action, callback) => {
        window[action] = (...args) => {
            if (!args.length) return callback();
            const [payload, ...rest] = args;
            return callback(normalizeNativePayload(payload), ...rest);
        };
        return;
    },
    // 移除监听回调
    remove: (action) => {
        delete window[action];
    },
}


export default MyJSBridge;
